import React, { useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Button, Stack } from '@mui/material';

const columns = [
  { field: 'id', headerName: 'ID', width: 50 },
  { field: 'sensor', headerName: 'センサー種別', width: 120 },
  { field: 'observation_mode', headerName: '観測モード', width: 120 },
  { field: 'polarization', headerName: '偏波', width: 100 },
  { field: 'observation_direction', headerName: '観測方向', width: 100 },
  { field: 'beam_no', headerName: 'ビームNO', width: 100 },
  { field: 'direction', headerName: '進行方向', width: 100 },
  { field: 'observation_date', headerName: '観測開始日', width: 100 },
  { field: 'observation_start_latitude_argument', headerName: '観測開始緯度引数', width: 200 },
  { field: 'observation_start_date_and_time', headerName: '観測開始時間', width: 200 },
  { field: 'observation_end_date', headerName: '観測終了日', width: 200 },
  { field: 'observation_end_latitude_argument', headerName: '観測終了緯度引数', width: 200 },
  { field: 'scene_center_path_number', headerName: 'シーン中心パス番号', width: 100 },
];

const ObservationTable = ({ data = [], onSelect }) => {
  // MUI v8 では差分型のrowSelectionModel
  const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });
  const [filterModel, setFilterModel] = useState({ items: [] });

  // 選択されているIDを取得するユーティリティ
  const getSelectedIds = (model) => {
    if (!model) return [];
    if (model.type === 'include') {
      return Array.from(model.ids);
    } else if (model.type === 'exclude') {
      // 全件選択から除外されているIDを除く
      return data.map((row) => row.id).filter((id) => !model.ids.has(id));
    }
    return [];
  };

  const handleSelectionModelChange = (newModel) => {
    setRowSelectionModel(newModel);
    const selectedIds = getSelectedIds(newModel);
    const selectedData = data.filter((d) => selectedIds.includes(d.id));
    onSelect?.(selectedData);
  };

  const handleClearFilters = () => {
    setFilterModel({ items: [] });
  };

  const handleExportJSON = () => {
    const selectedIds = getSelectedIds(rowSelectionModel);
    if (selectedIds.length === 0) {
      alert('まず1つ以上の行を選択してください');
      return;
    }
    const selectedData = data.filter((d) => selectedIds.includes(d.id));
    const jsonStr = JSON.stringify(selectedData, null, 2);
    const blob = new Blob([jsonStr], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'observations_selected.json';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleExportCSV = () => {
    const selectedIds = getSelectedIds(rowSelectionModel);
    if (selectedIds.length === 0) {
      alert('まず1つ以上の行を選択してください');
      return;
    }
    const selectedData = data.filter((d) => selectedIds.includes(d.id));
    const header = columns.map((col) => col.headerName).join(',');
    const rows = selectedData.map((row) =>
      columns
        .map((col) => {
          const value = row[col.field];
          if (value === null || value === undefined) return '';
          return `"${String(value).replace(/"/g, '""')}"`;
        })
        .join(',')
    );
    const csvContent = [header, ...rows].join('\n');
    const bom = new Uint8Array([0xef, 0xbb, 0xbf]);
    const blob = new Blob([bom, csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'observations_selected.csv';
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Stack direction="row" spacing={2} sx={{ mb: 1 }}>
        <Button variant="contained" color="primary" onClick={handleExportJSON}>
          JSONでダウンロード
        </Button>
        <Button variant="outlined" color="secondary" onClick={handleExportCSV}>
          CSVでダウンロード
        </Button>
        <Button variant="outlined" color="error" onClick={handleClearFilters}>
          フィルターを全解除
        </Button>
      </Stack>

      <div style={{ height: 500, overflow: 'auto' }}>
        <DataGrid
          rows={data}
          columns={columns}
          getRowId={(row) => row.id}
          pageSize={5}
          rowsPerPageOptions={[5]}
          checkboxSelection
          rowSelectionModel={rowSelectionModel}
          onRowSelectionModelChange={handleSelectionModelChange}
          filterModel={filterModel}
          onFilterModelChange={setFilterModel}
        />
      </div>
    </div>
  );
};

export default ObservationTable;
